import { render, staticRenderFns } from "./RightForYou.vue?vue&type=template&id=500c43de&scoped=true&"
import script from "./RightForYou.vue?vue&type=script&lang=js&"
export * from "./RightForYou.vue?vue&type=script&lang=js&"
import style0 from "./RightForYou.vue?vue&type=style&index=0&id=500c43de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c43de",
  null
  
)

export default component.exports